import { LeaseBillableEventDto } from '../dtos/lease-billable-event.dto';

/**
 * Lease billable events response DTO
 */
export class LeaseBillableEventsResponse {
	records!: LeaseBillableEventDto[];
}
